import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AnimatePresence } from 'framer-motion';
import '@/App.css';

// Pages
import Landing from '@/pages/Landing';
import Signup from '@/pages/Signup';
import Apply from '@/pages/Apply';
import Login from '@/pages/Login';
import CheckoutSuccess from '@/pages/CheckoutSuccess';
import Onboarding from '@/pages/Onboarding';
import Dashboard from '@/pages/Dashboard';
import Community from '@/pages/Community';
import PowerVault from '@/pages/PowerVault';
import AIGuide from '@/pages/AIGuide';
import LifestyleDesigner from '@/pages/LifestyleDesigner';
import ProfileAnalyzer from '@/pages/ProfileAnalyzer';
import IdeaLab from '@/pages/IdeaLab';
import Profile from '@/pages/Profile';
import Admin from '@/pages/Admin';
import CircleRoom from '@/pages/CircleRoom';
import Upgrade from '@/pages/Upgrade';
import Events from '@/pages/Events';

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('pivot_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Landing />} />
        <Route path="/signup" element={<Apply />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/login" element={<Login />} />
        <Route path="/checkout-success" element={<CheckoutSuccess />} />
        
        <Route path="/diagnostic" element={<ProtectedRoute><Navigate to="/onboarding" replace /></ProtectedRoute>} />
        <Route path="/diagnostic-results" element={<ProtectedRoute><Navigate to="/onboarding" replace /></ProtectedRoute>} />
        
        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
        <Route path="/academy" element={<ProtectedRoute><PowerVault /></ProtectedRoute>} />
        <Route path="/power-vault" element={<ProtectedRoute><PowerVault /></ProtectedRoute>} />
        <Route path="/ai-guide" element={<ProtectedRoute><AIGuide /></ProtectedRoute>} />
        <Route path="/lifestyle-designer" element={<ProtectedRoute><LifestyleDesigner /></ProtectedRoute>} />
        <Route path="/profile-analyzer" element={<ProtectedRoute><ProfileAnalyzer /></ProtectedRoute>} />
        <Route path="/idea-lab" element={<ProtectedRoute><IdeaLab /></ProtectedRoute>} />
        <Route path="/profile/:id" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
        <Route path="/circle/:id" element={<ProtectedRoute><CircleRoom /></ProtectedRoute>} />
        <Route path="/upgrade" element={<ProtectedRoute><Upgrade /></ProtectedRoute>} />
        <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnimatedRoutes />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
